module.exports = __webpack_public_path__ + "img/daily.90b46380.gif";